import { Configuration, LogLevel } from '@azure/msal-browser';
import { paths } from '@/routes/paths';
import { config } from '@/config';

/**
 * MSAL Configuration for Azure AD Authentication
 * Azure Entra ID Configuration
 */

// Configuration loaded at runtime (production) or from env vars (development)
const clientId = config.clientId;
const tenantId = config.tenantId;
const apiScope = config.apiScope;
const redirectUri = config.redirectUri;

/**
 * MSAL Configuration object
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirectUri,
    postLogoutRedirectUri: `${redirectUri}${redirectUri.endsWith('/') ? '' : '/'}${paths.login.slice(1)}`,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes for API access
 */
export const loginRequest = {
  scopes: ['User.Read'],
};

/**
 * Scopes for calling the backend API
 */
export const apiRequest = {
  scopes: apiScope ? [apiScope] : [],
};

/**
 * Check if authentication is enabled
 */
export const isAuthEnabled = (): boolean => {
  return !!(clientId && tenantId);
};

/**
 * Get the API scope for token acquisition
 */
export const getApiScopes = (): string[] => {
  return apiScope ? [apiScope] : [];
};
